import moment from 'moment'

const PERIOD_TYPE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
}

const covertToMMMYYYY = (month, year) => {
  return moment(`${month}/${year}`, 'MM/YYYY').format('MMM-YYYY')
}

export const formatListFilterTime = (list, timeFrequency, isDisabled) => {
  if (!Array.isArray(list) || list.length === 0 || isDisabled) return []
  if (timeFrequency === PERIOD_TYPE.YEARLY) {
    // Unique years, sorted desc
    const years = [...new Set(list.map((item) => item.year))].sort(
      (a, b) => b - a,
    )
    return years.map((year) => ({ label: String(year), value: String(year) }))
  }
  if (timeFrequency === PERIOD_TYPE.QUARTERLY) {
    // Unique quarter-year, sorted desc
    const quarters = [
      ...new Set(list.map((item) => `Q${item.quarter}-${item.year}`)),
    ].sort((a, b) => {
      // Sort by year desc, then quarter desc
      const [qA, yA] = a.replace('Q', '').split('-').map(Number)
      const [qB, yB] = b.replace('Q', '').split('-').map(Number)
      if (yA !== yB) return yB - yA
      return qB - qA
    })
    return quarters.map((q) => ({ label: q, value: q }))
  }
  if (timeFrequency === PERIOD_TYPE.MONTHLY) {
    // Unique month-year, sorted desc
    const months = [
      ...new Set(list.map((item) => covertToMMMYYYY(item.month, item.year))),
    ].sort((a, b) => {
      // Parse MMM-YYYY to date for sorting
      const dA = moment(a, 'MMM-YYYY')
      const dB = moment(b, 'MMM-YYYY')
      return dB - dA
    })
    return months.map((m) => ({ label: m, value: m }))
  }
  return []
}

// Helper to parse option value to params
export const parseValueToParams = (value, type) => {
  if (!value) return {}
  if (type === PERIOD_TYPE.YEARLY) {
    return { Year: value.value }
  }
  if (type === PERIOD_TYPE.QUARTERLY) {
    const match = value.value.match(/^Q(\d+)-(\d{4})$/)
    if (match) {
      return { Quarter: match[1], Year: match[2] }
    }
  }
  if (type === PERIOD_TYPE.MONTHLY) {
    const m = moment(value.value, 'MMM-YYYY')
    if (m.isValid()) {
      return { Month: m.month() + 1, Year: m.year() }
    }
  }
  return {}
}
